import React from "react";
import Chart from "react-apexcharts";
import "./Ceodb.scss";

const MoodOMeterPreview = () => {
    /* Radial chart */
    const radialOptions = {
        chart: { type: "radialBar" },
        plotOptions: {
            radialBar: {
                hollow: { size: "70%" },
                dataLabels: {
                    name: { show: false },
                    value: {
                        fontSize: "22px",
                        color: "#16a34a"
                    }
                }
            }
        },
        colors: ["#16a34a"],
        labels: ["Positive"]
    };

    /* Line chart */
    const lineOptions = {
        chart: {
            type: "line",
            toolbar: { show: false }
        },
        stroke: { curve: "straight", width: 2 },
        markers: { size: 4 },
        xaxis: {
            categories: [
                "2026-01-08", "2026-01-04", "2026-01-03", "2026-01-01",
                "2025-12-29", "2025-12-18", "2025-12-12",
                "2025-12-06", "2025-12-01", "2025-11-21",
                "2025-11-11", "2025-11-04", "2025-10-30", "2025-10-22"
            ]
        },
        yaxis: { min: 0, max: 100 }
    };

    /* Donut chart */
    const donutOptions = {
        labels: ["Very Positive", "Positive", "Neutral", "Negative", "Very Negative"],
        legend: { show: false },
        colors: ["#63b32e", "#9acd32", "#e3cd44", "#f06a4f", "#e83b3b"],
        dataLabels: {
            style: { colors: ["#fff"] }
        }
    };

    return (
        <div className="mood-meter-page">
            {/* LEFT */}
            <div className="left-section">
                {/* Positive Mood */}
                <div className="card">
                    <h4>Positive Mood</h4>

                    <div className="positive-mood">
                        <div className="mood-list">
                            <div><span>😊</span> 55%</div>
                            <div><span>😐</span> 11%</div>
                            <div><span>☹️</span> 34%</div>
                        </div>

                        <Chart
                            options={radialOptions}
                            series={[55]}
                            type="radialBar"
                            height={200}
                        />
                    </div>
                </div>

                {/* Positive Trend */}
                <div className="card">
                    <div className="card-header">
                        <h4>Positive Trend</h4>
                        <select>
                            <option>Daily</option>
                        </select>
                    </div>

                    <Chart
                        options={lineOptions}
                        series={[{ name: "Positive", data: [35, 100, 72, 45, 0, 25, 68, 0, 100, 62, 67, 60, 48, 40] }]}
                        type="line"
                        height={250}
                    />
                </div>
            </div>

            {/* RIGHT */}
            <div className="right-section">
                <div className="card full-height">
                    <h4>Mood Distribution</h4>

                    <Chart
                        options={donutOptions}
                        series={[27, 28, 11, 18, 16]}
                        type="donut"
                        height={420}
                    />
                </div>
            </div>
        </div>
    );
};

export default MoodOMeterPreview;